export default __webpack_public_path__ + "static/media/harmony.bcce071f.svg";